import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { MEASURE_IMAGE_WIDTH_PX } from './sizeChartData'
import { sectionGap } from './styles'

export const SizeSelectLabel = styled(TypeStyle.HeadlineMicro)`
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const MeasurementSummary = styled.dl`
  ${sectionGap};
  align-items: center;
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: ${o => o.theme.borderRadius.md};
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: ${o => o.theme.spacing(5)};
`

export const MeasurementSummaryEntry = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
  min-width: 100px;
`

export const MeasurementSummaryLabel = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.text.secondary.on.background};
  font-weight: 700;
`

export const MeasurementSummaryValue = styled(TypeStyle.HeadlineExtraSmall)`
  margin: 0;
`

export const HowToMeasureList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
  list-style: none;
`

export const HowToMeasureItem = styled.li`
  display: flex;
  gap: ${o => o.theme.spacing(2)};
`

export const MeasureImageFrame = styled.div`
  border-radius: ${o => o.theme.borderRadius.md};
  flex-shrink: 0;
  overflow: hidden;
  width: ${MEASURE_IMAGE_WIDTH_PX}px;
`

export const MeasureText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(1)};
`

export const MeasureTipText = styled(TypeStyle.BodySmall)`
  font-weight: 400;
`
